module.exports = __webpack_public_path__ + "static/media/bouncer_rocker 0-6 - 100px.0e4349f8.png";